export default {
    cart: {
      account: '決済'
    },
    tips: {
      cart_success: "ショッピングカートに追加されました",
      add_success: "正常に追加されました",
      empty: "空の~",
      order_success: "おめでとうございます。注文は正常に送信されました",
      chose: "選んでください",
      un_pay_on_line: "現在、オンライン決済をサポートしていません",
      area_not_empty: "地域を空にすることはできません",
      name_not_empty: "名前は空白にできません",
      address_not_empty: "住所を入力してください",
      phone_not_empty: "電話番号が間違っている"
    },
    detail: {
      carriage: '運賃',
      surplus: '残り',
      goods_detail: '製品詳細',
      cart: 'カート',
      add_cart: 'カートに入れる',
      buy_now: 'ご購入手続きへ',
      CloseOrder:'完全な注文',
      Subtotal:'小計',
      mange:'管理',
      Total:'合計',
      jian:'ピース',
      Delivery_method:'配達方法',
      paypaly_method:'支払い方法 ',
      paypaly1:'代金引換',
      paypaly2:'支払い',
      paypalyOut:'開発中、辛抱強く待ってください。'
  
    },
    order: {
      freeFreight:'運賃は無料です',
      allTotal:'商品総額',
      query:'注文のチェック',
      goods_info: '商品情報',
      pay_way: '配送方法とお支払い方法を選択してください',
      offline: '代金引換',
      online: 'オンライン決済',
      pick_info: '配送に関する情報',
      name_name: '名前',
      name: '宛先名前',
      phone_name: '電話',
      phone: '宛先携帯番号',
      area: '都道府県、市区町村など',
      region: '範囲',
      address_name: '住所',
      address: '番地、部屋番号、その他の情報',
      offer_order: '注文を提出する',
    },
    data: {
      Recipient_name:'受取人の名前',
      Recipient_nameTips:'スムーズに受信できるように、受信者の本名を入力してください',
      Select_M:'店舗を選択',
      email:"宛先メールアドレス",
      Select_M_number:'店舗名',
      Selected_store_name:'店舗名を選択',
      Shop_address:'ショップアドレス',
      address:'住所を選択してください',
      Choose_payment_method:'選択したお支払い方法',
      default_address:'台湾',
    },
    indexdata:{
      index:'ホームページ',
      list:'リスト',
      placeholder:'検索キーワードを入力してください',
      Return:'戻る'
    },
    Product_details_page: {
      guarantee:'保証',
      guarantee_texts: '本物の保証、1つの偽の補償、4つの迅速な払い戻し',
      numbertext:'量',
      Select_product_specification:'規格と数量を選ぶ',
      Package_selection: 'コース選択',
      Buy_now: '今買う'
    },
    newOrder:{
      Order_information:'注文情報',
      Selection_of_delivery_and_payment_methods:'配送方法とお支払い方法を選択してください',
      Delivery_place:'お届け先の住所',
      tw:'台湾',
      Delivery_method:'配送方法',
      Sub_total:'小計',
      Freight_charges:'品',
      Total:'合計',
      Go_to_checkout:'チェックアウトに行きます',
    },
    order3: {
      Total:'合計  ￥',
      Delivery_information:'配送に関する情報',
      Freight_charges:'品',
      change:'変化する',
      Search_shop:'店舗検索',
      Order_notes:'注文メモ',
      Payment_information:'支払情報',
      Payment_method_selected:'選択したお支払い方法',
      Submit_order: '注文を送信',
      xxdz:'詳細な住所を入力してください',
      Select_address: '住所を選ぶ',
      Tell_the_seller:'売り手に伝えたいですか？',
      freight:"運賃:",
      Spesifikasi_jualan_pendek:'仕様は完売しました',
    },
    index:{
      placeholder:'検索キーワードを入力してください',
      index:'ホーム',
      list: 'リスト',
      language:'日本語'
    },
    Guarantee:{
      num:'数量',
      Pickup_method:'サポート7-11、ファミリースーパーマーチャントピックアップ',
      Guarantee:'品質保証',
      Freight:'送料無料',
      Commodity_pic:'商品画像',
      Options:'オプション',
      selected:'選ぶ済み商品',
      Total_price:'合計注文金額',
      Finally_cope:'ついに対処',
      message:'注释',
      region:'郡/市',
      region_s:'町/町/地区',
      country:'国/地域'
    },
    Pay:{
      language:'代金引換',
      money:'￥',
      to:'数秒でホームページにジャンプ',
      postcode:'郵便番号',
      setMeal:'コンビネーションパッケージ価格',
      success:'注文に成功しました!',
      time:'販売者は10分以内に注文を自動的に確認します!',
      realMoney:'実際に支払われた金額',
      orderNumber:'注文番号',
      waitFor:'商人は発送しませんでした。しばらくお待ちください'
    },
    comment:{
      comment:'コメントを投稿',
      Praise:'賞賛',
      Average:'平均',
      Badreview:'悪いレビュー',
      submitcomments:'コメントを送信する',
      PleaseEnteraComment:'コメントを入力してください'
    },
    Toast:{
      inputName:'名前を入力してください',
      inputPhone:'電話番号を入力してください',
      inputZip:'郵便番号を入力してください',
      inputAddress:'詳しい住所を入力する',
      inputAlertAddress:'アドレスが配信されていません。別のアドレスに変更してください',
    },
    contactUs:{
      callMe:'詳しく知ることができ<br> 私たちのFacebookのページのメッセンジャーに連絡してください！',
      afterShop:`買った 連絡:<br>Email: <a href='mailto:service325@hotmail.com'>service325@hotmail.com</a>`,
      confirm:'確認',
      shortSale:'この規格は売り切れました',
    },
    ensure:{
      introduce:'品物情報',
      Specifications:'品物規格',
      ensure:'品物保証',
      di:'',
      commodity:'点目'
    },
    wuliu:{
      orderSearch:'オーダーの調べ',
      provide:'このデータの物流トラッキング',
      OrderOrLogistics:'オーダー番号/物流トラッキング番号(一つの項目を記入して調べできる)',
      orderPlaceho:'相関の情報を記入して調べる',
      query:'オーダー番号の調べ',
      Tips:'お知らせ',
      Tipsinfo:'商品を受け取り後に質問がある場合はカスタマーサービスservice325@hotmail.comに連絡してくささい。ご名前/連絡方法/オーダー番号を教えてください、早めに返事しております、ショッピングお楽しみください！',
    }
  }
  


// WEBPACK FOOTER //
// ./src/i18n/ja.js